export enum ManagerQueueIdentifyColumns {
  source,
  contact,
  pageCount,
  receivedDate,
  age,
}
